// src/pages/Dashboard/Dashboard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDashboard } from '../../hooks/useDashboard';
import { useWatchlist } from '../../hooks/useWatchlist';
import { useAuth } from '../../context/AuthContext';
import WalletBalance from '../../components/dashboard/WalletBalance/WalletBalance';
import PendingOrdersWidget from '../../components/dashboard/PendingOrdersWidget/PendingOrdersWidget';
import InviteWidget from '../../components/dashboard/InviteWidget/InviteWidget';
import VideosWidget from '../../components/dashboard/VideosWidget/VideosWidget';
import NewsWidget from '../../components/dashboard/NewsWidget/NewsWidget';
import AlertsWidget from '../../components/dashboard/AlertsWidget/AlertsWidget';
import CopyTradeWidget from '../../components/dashboard/CopyTradeWidget/CopyTradeWidget';
import TrendingStocks from '../../components/dashboard/TrendingStocks/TrendingStocks';
import WatchlistSection from '../../components/dashboard/WatchlistSection/WatchlistSection';
import PortfolioSummary from '../../components/dashboard/PortfolioSummary/PortfolioSummary';
import InvestmentPlans from '../../components/dashboard/InvestmentPlans/InvestmentPlans';
import PlanCards from '../../components/dashboard/PlanCards/PlanCards';
import CurrencyToggle from '../../components/dashboard/CurrencyToggle/CurrencyToggle';
import dashboardLogo from '../../assets/images/dashboard-logo.PNG';
import './Dashboard.css';

const socialLinks = [
  {
    name: 'X',
    url: 'https://x.com/growwithtrexar?s=21',
    className: 'social-x',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="social-svg">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/growwithtrexar?igsh=OWM4M3VhbTR1MXA0&utm_source=qr',
    className: 'social-instagram',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="social-svg">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    ),
  },
  {
    name: 'Telegram',
    url: 'https://t.me/trexarng',
    className: 'social-telegram',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="social-svg">
        <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
      </svg>
    ),
  },
];

/* ── Small inline logo loader — used for page-level loading states ── */
const MiniLogoLoader = ({ label }) => (
  <div className="mini-loader-wrap">
    <div className="mini-logo">
      <div className="mini-bar-wrap mini-bar-left">
        <div className="mini-bar-fill mini-fill-left" />
      </div>
      <div className="mini-bar-wrap mini-bar-center">
        <div className="mini-bar-fill mini-fill-center" />
      </div>
      <div className="mini-bar-wrap mini-bar-right">
        <div className="mini-bar-fill mini-fill-right" />
      </div>
    </div>
    {label && <p className="mini-loader-label">{label}</p>}
  </div>
);

const Dashboard = () => {
  const { 
    walletData, 
    trendingStocks, 
    portfolio, 
    investmentPlans, 
    loading, 
    error 
  } = useDashboard();

  const { watchlist, loading: watchlistLoading } = useWatchlist();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
  };

  if (loading) {
    return (
      <div className="dashboard-loading">
        <MiniLogoLoader label="Loading dashboard..." />
      </div>
    );
  }

  if (error) {
    return <div className="dashboard-error">Error loading dashboard: {error}</div>;
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div className="header-top">
          <div className="logo-welcome-container">
            <img 
              src={dashboardLogo} 
              alt="Dashboard Logo" 
              className="dashboard-logo"
            />
            {/* Desktop: icons beside logo */}
            <div className="social-icons-desktop">
              {socialLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`social-icon-link ${link.className}`}
                  title={link.name}
                >
                  {link.icon}
                </a>
              ))}
            </div>
            {/* Mobile: welcome text + icons below it */}
            <div className="mobile-welcome-block">
              {user && (
                <span className="mobile-welcome-text">
                  Welcome, {user.username}
                </span>
              )}
              <div className="social-icons-mobile">
                {socialLinks.map((link) => (
                  <a
                    key={link.name}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`social-icon-link ${link.className}`}
                    title={link.name}
                  >
                    {link.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
          
          <div className="currency-logout-container">
            <CurrencyToggle />
            <span 
              className="mobile-logout-text"
              onClick={handleLogout}
            >
              Logout
            </span>
          </div>
        </div>
        <div className="subtitle-row">
          <p>Track and manage your investments</p>
          <button
            type="button"
            className="terms-icon-link"
            onClick={() => navigate('/terms')}
            title="Terms & Conditions"
            aria-label="Terms & Conditions"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="terms-icon-svg">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="9" y1="13" x2="15" y2="13" />
              <line x1="9" y1="17" x2="15" y2="17" />
              <line x1="9" y1="9" x2="10" y2="9" />
            </svg>
          </button>
        </div>
        <a
          href="https://t.me/damilola_trexarng"
          target="_blank"
          rel="noopener noreferrer"
          className="need-help-link"
        >
          Need help?
        </a>
      </div>

      <div className="dashboard-content">
        {/* Wallet Balance Section */}
        <section className="dashboard-section">
          <WalletBalance 
            balance={walletData?.balance || 0}
            availableBalance={walletData?.availableBalance || 0}
            currency={walletData?.currency}
            onDeposit={() => window.location.href = '/deposit'}
            onWithdraw={() => window.location.href = '/withdraw/pin'}
          />
        </section>

        {/* Widgets Section — 6 widgets: 6-across on desktop, 3×2 on mobile */}
        <section className="dashboard-section widgets-section">
          <div className="widgets-container">
            <PendingOrdersWidget />
            <InviteWidget />
            <VideosWidget />
            <NewsWidget />
            <AlertsWidget />
            <CopyTradeWidget />
          </div>
        </section>

        {/* Trending Stocks Section */}
        <section className="dashboard-section">
          <TrendingStocks stocks={trendingStocks} />
        </section>

        {/* Watchlist Section */}
        <section className="dashboard-section">
          <WatchlistSection watchlist={watchlist} loading={watchlistLoading} />
        </section>

        {/* Portfolio Section */}
        <section className="dashboard-section">
          <PortfolioSummary holdings={portfolio} />
        </section>

        {/* Investment Plans Section */}
        <section className="dashboard-section">
          <InvestmentPlans plans={investmentPlans} />
        </section>

        {/* Plan Section */}
        <section className="dashboard-section full-width">
          <PlanCards />
        </section>
      </div>
    </div>
  );
};

export default Dashboard;